export { default } from './AboutTemplate';



// WEBPACK FOOTER //
// ./src/components/about/AboutTemplate/index.js